import { Entry } from '../Entry'

export function Entry20220518() {
  return (
    <Entry title="18/05/2022 - v3.0.8">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12622/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
